import * as React from 'react'

import ModalWrapper from 'components/ChannelView/ModalWrapper'

import './stylesButton.scss'
import { I18n } from 'react-redux-i18n'

const ModalMaxButtons = (props) => {

  const body = (
    <div className='body'>
      <div>{I18n.t('modal_max_buttons_modal_first_line')}</div>
      <div style={{ marginTop: '15px' }}>{I18n.t('modal_max_buttons_modal_second_line')}</div>
      <div className='buttons-container'>
        <div className='btn btn-primary' onClick={props.toggle}>{I18n.t('modal_max_buttons_modal_button_keep')}</div>
        <div className='btn btn-primary' onClick={props.replaceAction}>{I18n.t('modal_max_buttons_modal_button_replace')}</div>
      </div>
    </div>
  )

  return (
    <ModalWrapper
      id='modalMaxButtons'
      header={<h1>{I18n.t('modal_max_buttons_modal_header')}</h1>}
      body={body}
      isOpen={props.isOpen}
      toggle={props.toggle}
      showClose={false}
    />
  )
}

export default ModalMaxButtons